import { render, staticRenderFns } from "./GDriveImageLibraryDialog.vue?vue&type=template&id=a8bd0d52&scoped=true&"
import script from "./GDriveImageLibraryDialog.vue?vue&type=script&lang=js&"
export * from "./GDriveImageLibraryDialog.vue?vue&type=script&lang=js&"
import style0 from "./GDriveImageLibraryDialog.vue?vue&type=style&index=0&id=a8bd0d52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bd0d52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VIcon,VTab,VTabs})
